import ApiClient from '../ApiClient';

class UazapiChannelAPI extends ApiClient {
  constructor() {
    super('uazapi', { accountScoped: true });
  }

  connectPreview(data) {
    return axios.post(`${this.url}/connect_preview`, data);
  }

  checkPreviewStatus(data) {
    return axios.post(`${this.url}/check_preview_status`, data);
  }

  createInbox(data) {
    return axios.post(`${this.url}/create_inbox`, data);
  }

  getQRCode(inboxId) {
    return axios.get(`${this.url}/${inboxId}/qrcode`);
  }

  getStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/status`);
  }

  updateConfig(inboxId, data) {
    return axios.post(`${this.url}/${inboxId}/update_config`, data);
  }

  reconnect(inboxId) {
    return axios.post(`${this.url}/${inboxId}/reconnect`);
  }

  disconnect(inboxId) {
    return axios.post(`${this.url}/${inboxId}/disconnect`);
  }
}

export default new UazapiChannelAPI();
